module.exports = __webpack_public_path__ + "static/img/e-banner-m.bead2fa2.jpg";